import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col space-y-3" }

import IconGlyph from '@/lib/components/Icon/IconGlyph.vue';
import MedKitButton from '@/lib/components/Button/MedKitButton.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorState',
  props: {
  title: {
    type: String,
    required: true
  },
  icon: {
    type: String,
    default: 'offline-glyph-32'
  },
  details: {
    type: String,
    default: null
  },
  background: {
    type: Boolean,
    default: true
  },
  dark: {
    type: Boolean,
    default: false
  }
},
  emits: ["retry"],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["h-96 w-full space-y-6 flex items-center text-center justify-center flex-col", { 'bg-white rounded-lg border shadow': __props.background }])
  }, [
    _createVNode(IconGlyph, {
      name: __props.icon,
      size: "large",
      "data-dusk": `${__props.icon}-icon`
    }, null, 8, ["name", "data-dusk"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("span", {
        class: _normalizeClass(["text-lg font-semibold leading-tight", __props.dark ? 'text-white' : 'text-gray-900'])
      }, _toDisplayString(__props.title), 3),
      (__props.details)
        ? (_openBlock(), _createElementBlock("span", {
            key: 0,
            class: _normalizeClass(__props.dark ? 'text-white' : 'text-gray-500')
          }, _toDisplayString(__props.details), 3))
        : _createCommentVNode("", true)
    ]),
    _createVNode(MedKitButton, {
      kind: __props.dark ? 'dark' : 'secondary',
      label: _ctx.$t('platform.error.try-again'),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('retry')))
    }, null, 8, ["kind", "label"])
  ], 2))
}
}

})